import { render, staticRenderFns } from "./ReportNotes.vue?vue&type=template&id=b70ffbc2"
import script from "./ReportNotes.vue?vue&type=script&lang=js"
export * from "./ReportNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports